import React from "react";
import { MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSideRail } from "@/contexts/SideRailContext";
import { TopNavigation } from "@/components/layout/TopNavigation";

export const HeaderActions: React.FC = () => {
  const { toggleSideRail } = useSideRail();

  return (
    <div className="flex items-center gap-3 shrink-0">
      <Button
        variant="outline"
        size="icon"
        className="md:hidden shrink-0 h-9 w-9"
        onClick={toggleSideRail}
        title="Ask Hobbes"
      >
        <MessageSquare className="h-4 w-4" />
        <span className="sr-only">Ask Hobbes</span>
      </Button>
      <div className="hidden md:flex">
        <TopNavigation />
      </div>
    </div>
  );
};
